/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAperture(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M3.916 7.5A9.208 9.208 0 002.75 12a9.23 9.23 0 00.587 3.25h5.054l-1.65-2.857a.748.748 0 01-.02-.034L3.916 7.5zM3.304 5.68A10.702 10.702 0 001.25 12a10.715 10.715 0 00.917 4.35A10.76 10.76 0 0012 22.75c3.519 0 6.642-1.69 8.604-4.304a.747.747 0 00.092-.125A10.702 10.702 0 0022.75 12a10.715 10.715 0 00-.916-4.35A10.76 10.76 0 0012 1.25c-3.519 0-6.642 1.69-8.604 4.304a.746.746 0 00-.092.125zm1.55.447L7.38 10.5 9.04 7.628l.002-.005 2.814-4.872a9.231 9.231 0 00-7 3.375zm8.662-3.252L10.99 7.25h8.95a9.257 9.257 0 00-6.423-4.376zm7.147 5.876h-5.054l1.65 2.857a.758.758 0 01.02.034l2.805 4.858A9.208 9.208 0 0021.25 12a9.23 9.23 0 00-.587-3.25zm-1.517 9.124L16.62 13.5l-4.475 7.749a9.231 9.231 0 007-3.375zm-8.662 3.252l2.527-4.376h-8.95a9.257 9.257 0 006.423 4.376zm-.361-5.876h3.754L15.754 12l-1.877-3.25h-3.754L8.246 12l1.877 3.25z'
      />
    </svg>
  );
}

export default SvgAperture;
